import * as React from "react";
import {
  Show,
  SimpleShowLayout,
  TextField,
  ImageField,
  ReferenceField,
  TopToolbar,
  EditButton,
  BooleanField
} from "react-admin";

const OfferingShowActions = ({ basePath, data, resource }) => (
  <TopToolbar>
    <EditButton basePath={basePath} record={data} />
  </TopToolbar>
);

const OfferShow = (props) => (
  <Show {...props} actions={<OfferingShowActions />}>
    <SimpleShowLayout>
      <ImageField source="offerImage._url" label="Offer View" />
      <TextField source="offerTitle" label="Offer" />
      <ReferenceField label="User" source="user.id" reference="User">
        <TextField source="name" />
      </ReferenceField>
      <BooleanField lable="Approve" source="isApproved" />
    </SimpleShowLayout>
  </Show>
);

export default OfferShow;
